import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.number.constructor.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "date-top"
};
var _hoisted_2 = {
  class: "value"
};
var _hoisted_3 = {
  class: "value"
};
var _hoisted_4 = {
  class: "value"
};
import { ref, computed, watch } from "vue";
import Common from "@/components/dialog/src/Common.vue";
import { showToast } from "@/utils/toastUtil";
import dayjs from "dayjs";
import Dialog from "../dialog/dialog";
export default {
  __name: 'baseDatePicker',
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    value: {
      type: Number,
      default: 0
    }
  },
  emits: ["update:visible", "update:value"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var currentDate = ref([new Date().getFullYear(), new Date().getMonth(), new Date().getDate()]);
    var minDate = new Date(1900, 0, 1);
    var maxDate = new Date(dayjs.tz().startOf("days"));
    var emits = __emit;
    var visibleReal = computed({
      get: function get() {
        return props.visible;
      },
      set: function set(val) {
        emits("update:visible", val);
      }
    });
    watch(function () {
      return props.visible;
    }, function (val) {
      if (val && props.value !== 0) {
        currentDate.value = [new Date(props.value).getFullYear(), new Date(props.value).getMonth() + 1, new Date(props.value).getDate()];
      } else if (props.value === 0) {
        currentDate.value = [new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate()];
      }
    });
    function handleConfirm() {
      return _handleConfirm.apply(this, arguments);
    }
    function _handleConfirm() {
      _handleConfirm = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var birthDay;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              birthDay = dayjs.tz(currentDate.value.join("-")).startOf("days").valueOf();
              emits("update:value", birthDay);
              emits("update:visible", false);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handleConfirm.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      var _component_van_date_picker = _resolveComponent("van-date-picker");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(Common, {
        visible: visibleReal.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return visibleReal.value = $event;
        }),
        "ok-text": _ctx.$t('select'),
        title: _ctx.$t('birthday'),
        "show-close-btn": "",
        "without-cancel": "",
        "show-bottom-shadow": "",
        "on-ok": handleConfirm
      }, {
        content: _withCtx(function () {
          return [_createVNode(_component_van_date_picker, {
            modelValue: currentDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return currentDate.value = $event;
            }),
            "show-toolbar": false,
            "min-date": _unref(minDate),
            "max-date": _unref(maxDate)
          }, {
            "columns-top": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("year")), 1), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("month")), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("day")), 1)])];
            }),
            _: 1
          }, 8, ["modelValue", "min-date", "max-date"])];
        }),
        _: 1
      }, 8, ["visible", "ok-text", "title"])]);
    };
  }
};